export const communication = {
    digitalMaterial: "Digitalt material",
    tastings: "Provsmakningar",
    storeMaterial: "Butiksmaterial",
    campaignMaterial: "Kampanjmaterial",
    news: "Nyheter",
};
